import { AbstractControl, ValidationErrors } from "@angular/forms";

export function fieldMatchValidator(control: AbstractControl) {
  const { password, passwordConfirm } = control.value;

  // avoid displaying the message error when values are empty
  if (!passwordConfirm || !password) {
    return null;
  }

  if (passwordConfirm === password) {
    return null;
  }

  return { fieldMatch: { message: 'Password Not Matching' } };
}

export function emailValidator(control: AbstractControl) {
  // RFC 2822 compliant regex
  if (control.value && control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
    return null;
  } else {
    return { invalidEmailAddress: { message: 'Invalid email address' } };
  }
}

export function passwordValidator(control: AbstractControl) {
  // {6,100}           - Assert password is between 6 and 100 characters
  // (?=.*[0-9])       - Assert a string has at least one number
  if (control.value && control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
    return null;
  } else {
    return { invalidPassword: { message: 'Invalid password. Password must be at least 6 characters long, and contain a number.' } };
  }
}

export function creditCardValidator(control: AbstractControl) {
  // Visa, MasterCard, American Express, Diners Club, Discover, JCB
  if (control.value && control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
    return null;
  } else {
    return { invalidCreditCard: { message: 'Is invalid credit card number' } };
  }
}

export function validDateValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  console.log('[validDateValidator] Valore ricevuto:', value);

  if (!value) {
    // console.log('[validDateValidator] Valore vuoto, ritorno null');
    return null; // evita errore se il campo è vuoto
  }

  const regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])$/;
  if (!regex.test(value)) {
    console.warn('[validDateValidator] Regex non superata');
    return { validDate: { message: 'Formato non valido. Usa gg-MM' } };
  }

  const [dayStr, monthStr] = value.split('-');
  const day = parseInt(dayStr, 10);
  const month = parseInt(monthStr, 10);

  console.log(`[validDateValidator] Parsed day: ${day}, month: ${month}`);

  const testDate = new Date(2020, month - 1, day);
  console.log('[validDateValidator] Test date:', testDate);

  if (testDate.getDate() !== day || testDate.getMonth() !== month - 1) {
    console.warn('[validDateValidator] Data non valida (es. giorno/mese inconsistente)');
    return { validDate: { message: 'Data non valida (es. 31-04 non esiste)' } };
  }

  console.log('[validDateValidator] Validazione superata');
  return null;
}

